module.exports = __webpack_public_path__ + "static/media/avatar.13540205.svg";